import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return Object.fromEntries(data.map(item => [item.id, item]))
  }, [data]) // eslint-disable-line
}
